import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux";
import { getProjects } from "src/store/project";

const SchedulePopup = ({ isOpen, togglePopup, addTask, projectList, id, existProject, addHoliday, holidayArea }) => {
  const dispatch = useDispatch();
  const projectData = useSelector((state) => state.project.data)
  const [keyword, setKeyword] = useState("")
  const [filteredProjects, setFilteredProjects] = useState([])
  const [selectedProjects, setSelectedProjects] = useState([])
  const [selectedHolidayKind, setSelectedHolidayKind] = useState(null);
  
  useEffect(() => {
    if (existProject && existProject.length > 0) {
      setSelectedProjects(
        existProject.map((project) => ({
          ...project,
          id: project.project_id,
          name_abbreviation: project.name_abbreviation || project.project_name,
        }))
      );
    }
  }, [existProject]);

  const handleSearch = async () => {
    const params = {
      name_abbreviation: keyword,
    }
    dispatch(getProjects(params));

    const existingProjectIds = existProject?.map((p) => p.project_id) || [];
    const filtered = projectData
      .flatMap((client) =>
        client.projects.map((project) => ({
          ...project,
          client_name: client.client_name,
          client_id: client.client_id,
        }))
      )
      .filter(
        (project) =>
          project.name_abbreviation?.toLowerCase().includes(keyword.toLowerCase()) &&
          !existingProjectIds.includes(project.id)
      );

    setFilteredProjects(filtered);
  };

  const handleHolidayKindChange = (holiday) => {
    setSelectedHolidayKind((prev) =>
      prev?.value === holiday.value ? null : holiday
    );
  };


  const handleProjectSelect = (project) => {
    if (!project.name_abbreviation) {
      console.error('Project has no name_abbreviation');
      return;
    }
    setSelectedProjects((prevSelectedProjects) => {
      const isSelected = prevSelectedProjects.some((p) => p.id === project.id)
      if (isSelected) {
        return prevSelectedProjects.filter((p) => p.id !== project.id)
      } else {
        return [...prevSelectedProjects, project]
      }
    })
  }

  const handleBoxClick = (e) => {
    e.stopPropagation()
  }
  const handeleTaskAdd = () => {

    if (holidayArea?.length > 0 && selectedProjects.length > 0) {
      if ([3, 4, 5, 6, 7].includes(holidayArea[0].holiday_cd)) {
        alert("It's a holiday, so you can't select a project.");
        return;
      }
    }

    const existingProjectIds = existProject?.map(p => p.project_id) || [];

    if (selectedProjects.length === 0 && selectedHolidayKind) {
      addHoliday(selectedHolidayKind);
      togglePopup();
      return;
    }

    if (selectedProjects.length > 0 && selectedHolidayKind && selectedHolidayKind.value >= 3) {
      alert("You have selected leave today, so you cannot select a project.");
      return;
    }

    selectedProjects.forEach((project) => {
      if (!existingProjectIds.includes(project.id)) {
        addTask({ ...project });
      }
    });

    if (selectedHolidayKind) {
      addHoliday(selectedHolidayKind);
    }

    togglePopup();
  };

  if (!isOpen) return null

  return (
    <nav className="popup-area jq-popup" onClick={togglePopup}>
      <div className="popup-scroll" onClick={(e) => e.stopPropagation()}>
        {id ? null :
          <><h2 className="h4 text-center">
            <span className="glyphicon glyphicon-home" aria-hidden="true"></span> leave
          </h2><div className="form-group form-group-block" style={{ width: "100%" }}>
              {[
                { value: 1, label: "Morning leave" },
                { value: 2, label: "Afternoon leave" },
                { value: 7, label: "Substitute leave" },
                { value: 3, label: "Paid leave" },
                { value: 4, label: "Special leave" },
                { value: 5, label: "Absence" },
              ].map((holiday) => (
                <div className="col-lg-4 col-sm-6 col-xs-12 jq_holiday_kind" key={holiday.value}>
                  <label
                    className={`btn btn-block ${selectedHolidayKind?.value === holiday.value ? "btn-success" : "btn-default"}`}
                  >
                    <input
                      type="checkbox"
                      name="holiday_kind"
                      value={holiday.value}
                      checked={selectedHolidayKind?.value === holiday.value}
                      onChange={() => handleHolidayKindChange(holiday)} />
                    {holiday.label}
                  </label>
                </div>
              ))}
            </div></>
        }

        <h2 className="h4 text-center">
          <span className="glyphicon glyphicon-plus-sign" aria-hidden="true"></span> project search
        </h2>

        <div className="form-group" style={{ width: "95%", textAlign: "left" }}>
          <input
            type="text"
            className="form-control jq_search_box"
            name="keyword"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="Project"
            style={{ width: "95%", display: "inline", marginBottom: "10px" }}
            onClick={handleBoxClick}
          />
          <button
            id="jq_search_box_btn"
            className="btn btn-success"
            style={{ marginTop: "10px" }}
            onClick={handleSearch}
          >
            Text Search
          </button>
        </div>

        <div className="form-group search" style={{
          textAlign: "left",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "flex-start",
          gap: "8px",
        }}>
          {filteredProjects.map((project) => (
            <label key={project.id} className="btn btn-default jq_task mr5">
              <input
                type="checkbox"
                name="tasks"
                data-client_id={project.client_id}
                data-client_name={project.client_name}
                data-project_id={project.id}
                data-project_name={project.name_abbreviation}
                data-start_date={project.start_date}
                data-end_date={project.end_date}
                value={project.id}
                onChange={() => handleProjectSelect(project)}
                checked={selectedProjects.some((p) => p.id === project.id)}
              />
              [{project.client_name}] {project.name_abbreviation}
            </label>
          ))}
        </div>

        <div className="jq_choice_box show_area" style={{ textAlign: "left" }}>
          {selectedProjects.map((project) => (
            <p key={project.id} className="btn btn-success" style={{ margin: "3px" }}>
              {project.name_abbreviation}
            </p>
          ))}
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12 form-button">
          <button className="btn btn-success btn-lg btn-block jq_ins_btn" type="button" onClick={handeleTaskAdd}>
            Register
          </button>
        </div>
      </div>

      <div className="popup-close jq-popup-close" onClick={togglePopup}>
        <span className="glyphicon glyphicon-remove" aria-hidden="true"></span>
      </div>
    </nav>
  )
}

export default SchedulePopup

